//imports and style imports 
import React, { useState, useEffect } from "react";
import {phone} from 'phone';
import { postcodeValidator} from 'postcode-validator';
import emailValidator from 'email-validator';
import StripePaymentForm from "./StripePaymentForm";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import "./ClassSignup.scss";

//env variables. 
const BASE_URL_BACKEND = process.env.REACT_APP_BASE_URL_BACKEND; 
const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const ClassSignup = () => {
   
    //we're going to keep prospect type and status as null. The stored procedure in the backend takes care of them.
    const initialValues = {
        email: "",
        firstname : "",
        lastname : "",
        address : "",
        city : "",
        state : "", // dropdown 
        postalCode : "",
        phone: "",
        company : "",
        etb_user: 0,
    };

    const initialTimeValues = {
        baseTime: {
            days: 0,
            hours: '00',
            minutes: '00',
            seconds: '00',
            timeUp: false
        },
        closestDate: ''
    }

    //destructure from useState... Set state with initial values object. 
    /*
    Did submit will only be set by a function setStripeStatus.
    If didSubmit is true than we can sendData to database and email. 
    */
    const [timeValues, setTimeValues] = useState(initialTimeValues);
    const [availableClasses, setAvailableClasses] = useState([]);
    const [classCart, setClassCart] = useState([]);
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});
    const [didSubmit, setDidSubmit] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const [userMsg, setUserMsg] = useState();
    const [paid, setPaid] = useState(1);
    
    //for stripe...
    const stripeFormTheme = {
        theme: 'stripe',
    };

    const stripeOptions = {
        clientSecret,
        appearance: stripeFormTheme,
    };

    useEffect(()=>{
        getClasses();
    },[]);

   
    
    useEffect(()=>{
        if(!availableClasses.length < 1){
            getClosestDate();
        }
        console.log(availableClasses);
    },[availableClasses.length]);

    useEffect(()=>{
        if(Object.keys(formErrors).length === 0 && isSubmitting){
            submit();
        }else{
            setIsSubmitting(false);
        }
    },[Object.keys(formErrors).length, isSubmitting]);

    useEffect(()=>{
        if(didSubmit){
            processPayingClassAttendee();
        }
    },[didSubmit]);

    const getClasses = async () => {

        await fetch(`${BASE_URL_BACKEND}/fxgUni/getClassList`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function(res){
            return res.json();
        }
        ).then(function(json){
            //a really hacky way to not be one update behind in state when use effect oly gets called once. (>.O)
            setAvailableClasses([0]);
            setAvailableClasses([...json.classes]);
        }).catch((error) => {
            console.error(error);
            setUserMsg('Sorry. We couldn\'t load the current class list');
        });
    };
    
    //when availableClasses and or their state set is called we want to run closest date, but NOT on init. 

    const setStripeStatus = (status) => {
        setDidSubmit(status);
    };

    const submit = async () => {

        if(getCartTotal()===0){
            setPaid(0);
            setStripeStatus(true);
        }else{
            const stripeData = {
                items : classCart,
            }
            const rspns = await createStripePaymentIntent({...stripeData});
        }  
    };

    /*
    The processPayingClassAttendee is rather clunky. 
    See node-backend comments. This end point will only be called if stripe says a customers payment is success (not complete -need webhook for that). It will add them to db with their class choices, and send off emails to staff and the client. Also adds to hubspot. 
    Server side required particular, stripped down arguments.
    Hence an object going back with another object args. That will contain all params required for 
    stored procedure call. 
    The remainder of the parameters (total and classes) where added later for easy email rendering with a breakdown of the client class details and total. 
    */

    const processPayingClassAttendee = async () => {

        //names and ids as a comma separated string are needed to store in database. 
        let namesAndIds = {};
        if(classCart.length>1){
            namesAndIds = classCart.reduce((prev,curr)=>{
                return {
                    classes_to_attend: prev.class_name + "," + curr.class_name,
                    class_ids: prev.class_id + "," + curr.class_id,
                };
            });   
        } else {
            namesAndIds = {
                classes_to_attend: classCart[0].class_name,
                class_ids: String(classCart[0].class_id)
            }
        }
        
        formValues.etb_user = parseInt(formValues.etb_user);
    
        const classes = availableClasses.filter(x => namesAndIds.class_ids.includes(String(x.class_id)));
    
        const total = getCartTotal(); 

        const pd = parseInt(paid);
    
        await fetch(`${BASE_URL_BACKEND}/fxgUni/createNewClassAttendee`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({args : {...formValues, ...namesAndIds, paid: pd}, total: total, classCart: classes})
        }).then(function(res){
            return res.json();
        }).then(function(json){
            console.log(json);
            return json;
        }).catch((error)=>{
            console.error(error);
            setUserMsg('Sorry. We couldn\'t add your information to the database.');
        });
    };

    //a stripe call will go here waiting for a response from the stripe popup.
    //as soon as we get that client secret we renderthe payment form component.

    const createStripePaymentIntent = async (stripeData) => {

        fetch(`${BASE_URL_BACKEND}/stripe-payment/create-payment-intent`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({...stripeData}),
          })
            .then((res) => res.json())
            .then((data) => setClientSecret(data.clientSecret))
            .catch((error)=>{
                console.error(error);
                setUserMsg('Sorry. We couldn\'t contact secure checkout. Please try again later');
            });

    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validate(formValues));
        setIsSubmitting(true);
    };

    //these REALLY need to be abstracted. They re literally in every one of my forms.
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormValues ({...formValues, [name]: value});
        //a little check to see if we're on email.  
    };

    //happens onblur of forms so we get 'real time' validation. 
    const checker = (e) => {
        setFormErrors(validate(formValues));
    };

    const validate = (values) => {
        let errors = {}; 

        for(const [key,value] of Object.entries(values)){
            if(!value){
                errors[key] = `This is a required field`;
            }
            if(Array.isArray(value) && value.length === 0){
                errors[key] = `Choose at least one option`;
            }
        }

        if(!emailValidator.validate(values.email)){
            errors.email = `Please enter a valid email address`;
        }

        if(postcodeValidator(values.postalCode, 'US')===false && postcodeValidator(values.postalCode, 'CA')===false){
            errors.postalCode = `Please enter a valid Postal Code`;
        }

        if(!phone(values.phone).isValid){
            errors.phone = `Please enter a valid Phone Number`;
        }

        return errors;
    };

    const CountDownTimer = () => {

        if(!timeValues.closestDate){
            return;
        }
   
        setInterval(() => {
            let difference = new Date(timeValues.closestDate) - +new Date();
            let days = Math.floor(difference / (1000 * 60 * 60 * 24));
            let hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            let minutes = Math.floor((difference / (1000 * 60)) % 60);
            let seconds = Math.floor((difference / (1000)) % 60);
            setTimeValues({...timeValues, baseTime: {
               hours: hours > 9 ? hours : `0${hours}`,
               minutes: minutes > 9 ? minutes : `0${minutes}`,
               seconds: seconds > 9 ? seconds : `0${seconds}`,
               days
            }});
        }, 1000);
        return (
            countDownToSoonestClass(timeValues.baseTime)
        );   
    };

   
   const getClosestDate = () =>{ 
        const mostRecentClass = availableClasses.reduce((prev,curr)=>{
            return new Date(prev.class_start_date).getTime() < new Date(curr.class_start_date).getTime() ? prev : curr;
        })
        setTimeValues({...timeValues, closestDate: mostRecentClass.class_start_date});
    };

    /*
    An ineffably long and hacky means to create a clickable list.
    Works well so I'm keeping it.    
    */

    const handleClick = (e) => {

        const class_id = parseInt(e.target.dataset.class_id);
        const price = parseInt(e.target.dataset.price);
        const name = e.target.dataset.class_name;

        const classObject = {
            class_name: name,
            class_id: class_id,
            price: price
        }

        if(!classCart.some(e=>e.class_id===class_id)){
            setClassCart([...classCart, classObject]);
        }else{
            const newArray = classCart.filter(e=>e.class_id!==class_id);
            setClassCart([...newArray]);
        }
    
    };

    const toMonthName = (monthNumber) => {
        const date = new Date();
        date.setMonth(monthNumber - 1);

        return date.toLocaleString('en-US', {
        month: 'short',
        });
    };

    //oldschool summation 
    const getCartTotal = () =>{
        let sum = 0;
        for(let i in classCart){
            sum += classCart[i].price;
        }
        return sum;
    };

    
    const ClassSelectorContainer = () => {
        return(
            <div className = 'classPicker'>
                <div className = 'form-row'>
                    <div className = 'classes-header'> 
                        <h3 id = 'classSelectTitle'>Choose Classes (one or more)</h3>
                        <p>Click/Tap once to add. Again to remove.</p>
                        <table>
                            <tbody>
                                <ClassEntryRow data = {availableClasses}/>
                            </tbody>
                        </table>
                        <div className = "priceTotal">
                            <div>Total:</div><h3>$ {getCartTotal()}</h3>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const ClassEntryRow = ({data}) => {

        return data.map((data, key) =>
        <tr key={key}>
            
            <td>
                <div 
                id = 'classBtn'
                className = {classCart.some(e=>e.class_id===data.class_id) ? 'clicked' : ''}
                onMouseDown={handleClick}
                type="text"
                data-price = {data.price}
                data-class_id = {data.class_id}
                data-class_name = {data.name}
                >
                    <div className = 'title' data-price = {data.price} data-class_id = {data.class_id} data-class_name = {data.name}>
                        {data.name}
                    </div>  
                    <div data-price = {data.price} data-class_id = {data.class_id} data-class_name = {data.name}>
                        Location: {data.class_location}
                    </div>
                    <div data-price = {data.price} data-class_id = {data.class_id} data-class_name = {data.name}>
                        Dates: {data.start_month_polite}/{data.start_day_polite}/{data.start_year_polite} - {data.end_month_polite}/{data.end_day_polite}{`/${data.end_year_polite}`}
                    </div>
                    <div data-price = {data.price} data-class_id = {data.class_id} data-class_name = {data.name}>
                        Price: ${data.price} 
                        <p data-price = {data.price} data-class_id = {data.class_id} data-class_name = {data.name} style = {{"display":"inline"}} id = "tooltip">{classCart.some(e=>e.class_id===data.class_id) ? 'Click/Tap to remove' : ''} </p>
                    </div>
                    
                </div>
            </td>
        </tr>
        );
    };

    const countDownToSoonestClass = (props) => {
        const {days, hours, minutes, seconds, timeUp} = props;
        const dayString = days > 1 ? 'days' : 'day';
        return(
            <>
            <div className = "time-unit">
                <div className = 'display'>
                    {days}
                </div>
                <div className = 'label'>
                    {dayString}
                </div>    
            </div>
            <div className = "time-unit">
                <div className = 'display'>
                    {hours}
                </div>
                <div className = 'label'>
                    hours
                </div>    
            </div>
            <div className = "time-unit">
                <div className = 'display'>
                    {minutes}
                </div>
                <div className = 'label'>
                    minutes
                </div>    
            </div>
            <div className = "time-unit">
                <div className = 'display'>
                    {seconds}
                </div>
                <div className = 'label'>
                    seconds
                </div>    
            </div>
        </>     
        );
    }

    const mainForm = () => {
        
            return (
                <div>
                    <div className='logo'>
                        <img title='eTruckBiz, Inc.' alt='eTruckBiz, Inc.' src='https://etruckbizimages.s3.us-east-2.amazonaws.com/newLogo/primary-logo-color-rgb-8in%4072ppi.png' width='325'></img>
                    </div>

                    <h3>Our next class is in:</h3>

                    <div className = 'class-countdown'> 
                        {availableClasses ? <CountDownTimer /> : ''}
                    </div>

                    <div className='form-prompt'>
                        <h3>Fill out this form and choose classes. Payment will be required. Thank you!</h3>
                    </div>

                    <div className="form-row">
                        <label id = 'emailLabel' htmlFor="email">
                            <p>Email</p> 
                        </label>
                        <input 
                            type="text"
                            name="email"
                            id="email"
                            value={formValues.email}
                            onChange={handleChange} onBlur={checker}
                            className={formErrors.email && "input-error"}
                        />
                        {formErrors.email && <span className="error">{formErrors.email}</span>}
                    </div>

                    <div className="form-row">
                        <label htmlFor="firstname">First Name</label>
                        <input 
                            type="text"
                            name="firstname"
                            id="firstname"
                            value={formValues.firstname}
                            onChange={handleChange} 
                            onBlur={checker}
                            className={formErrors.firstname && "input-error"}
                            />
                            {formErrors.firstname && <span className="error">{formErrors.firstname}</span>}
                    </div>

                    <div className="form-row">
                        <label htmlFor="lastname">Last Name</label>
                        <input 
                            type="text"
                            name="lastname"
                            id="lastname"
                            value={formValues.lastname}
                            onChange={handleChange} 
                            onBlur={checker}
                            className={formErrors.lastname && "input-error"}
                            />
                            {formErrors.lastname && <span className="error">{formErrors.lastname}</span>}
                    </div>

                    <div className="form-row">
                        <label htmlFor="address">Address</label>
                        <input
                            type="text"
                            name="address"
                            id="address"
                            value={formValues.address}
                            onChange={handleChange} onBlur={checker} 
                            className={formErrors.address && "input-error"}
                        />
                        {formErrors.address && (<span className="error">{formErrors.address}</span>)}
                    </div>

                    <div className="form-row">
                        <label htmlFor="city">City</label>
                        <input
                            type="text"
                            name="city"
                            id="city"
                            value={formValues.city}
                            onChange={handleChange} onBlur={checker} 
                            className={formErrors.city && "input-error"}
                        />
                        {formErrors.city && (<span className="error">{formErrors.city}</span>)}
                    </div>

                    <div className="form-row">
                    <label htmlFor="state">State</label>
                    <select
                        id="state" 
                        name="state"
                        value={formValues.state}
                        onChange = {handleChange} 
                        className={formErrors.state && "input-error"}
                    >
                        <option value="select">Select One</option>
                        <optgroup label="U.S. States/Territories">
                                <option value="AK">Alaska</option>
                                <option value="AL">Alabama</option>
                                <option value="AR">Arkansas</option>
                                <option value="AZ">Arizona</option>
                                <option value="CA">California</option>
                                <option value="CO">Colorado</option>
                                <option value="CT">Connecticut</option>
                                <option value="DC">District of Columbia</option>
                                <option value="DE">Delaware</option>
                                <option value="FL">Florida</option>
                                <option value="GA">Georgia</option>
                                <option value="HI">Hawaii</option>
                                <option value="IA">Iowa</option>
                                <option value="ID">Idaho</option>
                                <option value="IL">Illinois</option>
                                <option value="IN">Indiana</option>
                                <option value="KS">Kansas</option>
                                <option value="KY">Kentucky</option>
                                <option value="LA">Louisiana</option>
                                <option value="MA">Massachusetts</option>
                                <option value="MD">Maryland</option>
                                <option value="ME">Maine</option>
                                <option value="MI">Michigan</option>
                                <option value="MN">Minnesota</option>
                                <option value="MO">Missouri</option>
                                <option value="MS">Mississippi</option>
                                <option value="MT">Montana</option>
                                <option value="NC">North Carolina</option>
                                <option value="ND">North Dakota</option>
                                <option value="NE">Nebraska</option>
                                <option value="NH">New Hampshire</option>
                                <option value="NJ">New Jersey</option>
                                <option value="NM">New Mexico</option>
                                <option value="NV">Nevada</option>
                                <option value="NY">New York</option>
                                <option value="OH">Ohio</option>
                                <option value="OK">Oklahoma</option>
                                <option value="OR">Oregon</option>
                                <option value="PA">Pennsylvania</option>
                                <option value="PR">Puerto Rico</option>
                                <option value="RI">Rhode Island</option>
                                <option value="SC">South Carolina</option>
                                <option value="SD">South Dakota</option>
                                <option value="TN">Tennessee</option>
                                <option value="TX">Texas</option>
                                <option value="UT">Utah</option>
                                <option value="VA">Virginia</option>
                                <option value="VT">Vermont</option>
                                <option value="WA">Washington</option>
                                <option value="WI">Wisconsin</option>
                                <option value="WV">West Virginia</option>
                                <option value="WY">Wyoming</option>
                        </optgroup>
                        <optgroup label="Canadian Provinces">
                                <option value="AB">Alberta</option>
                                <option value="BC">British Columbia</option>
                                <option value="MB">Manitoba</option>
                                <option value="NB">New Brunswick</option>
                                <option value="NF">Newfoundland</option>
                                <option value="NT">Northwest Territories</option>
                                <option value="NS">Nova Scotia</option>
                                <option value="NU">Nunavut</option>
                                <option value="ON">Ontario</option>
                                <option value="PE">Prince Edward Island</option>
                                <option value="QC">Quebec</option>
                                <option value="SK">Saskatchewan</option>
                                <option value="YT">Yukon Territory</option>
                        </optgroup>
                        </select>
                        {formErrors.state && <span className="error">{formErrors.state}</span>}
                </div>

                
                    <div className="form-row">
                        <label htmlFor="postalCode">Postal Code</label>
                        <input 
                            type="text"
                            name="postalCode"
                            id="postalCode"
                            value={formValues.postalCode}
                            onChange={handleChange} onBlur={checker}
                            className={formErrors.postalCode && "input-error"}
                        />
                        {formErrors.postalCode && <span className="error">{formErrors.postalCode}</span>}
                    </div>

                    <div className="form-row">
                        <label htmlFor="phone">Phone Number</label>
                        <input 
                            type="text"
                            name="phone"
                            id="phone"
                            value={formValues.phone}
                            onChange={handleChange} onBlur={checker}
                            className={formErrors.phone && "input-error"}
                        />
                        {formErrors.phone && <span className="error">{formErrors.phone}</span>}
                    </div>

                    <div className="form-row">
                        <label htmlFor="company">Company</label>
                        <input 
                            type="text"
                            name="company"
                            id="company"
                            value={formValues.company}
                            onChange={handleChange} onBlur={checker}
                            className={formErrors.company && "input-error"}
                        />
                        {formErrors.company && <span className="error">{formErrors.company}</span>}
                    </div>

                    <label htmlFor = "etb_user" onChange={handleChange} onBlur={checker}>
                        <h3 id = "recordQuestion">Is your company an eTruckBiz subscriber?</h3>

                        <div className='radio-container'>
                            <input 
                                id = "etb_user"
                                type="radio"
                                name="etb_user"                                
                                value = "1"
                                className={formErrors.etb_user && "input-error"}
                            />
                            <label htmlFor="etb_user" className = 'radio'>Yes</label>
                        </div>

                        <div className='radio-container'>
                            <input 
                                id = "etb_user"
                                type="radio"
                                name="etb_user"
                                value="0"
                                className={formErrors.etb_user && "input-error"}
                            />
                            <label htmlFor="etb_user" className = 'radio'>No</label>
                        </div>  

                    </label>
                
                    <span className="error">{formErrors.etb_user}</span>

                </div>
            );
    }

    //Recall submission success only gets set in stripe payment form. 
    if(didSubmit){
        return(
            <div className = 'container'>
                <div className='logo'>
                    <img title='eTruckBiz, Inc.' alt='eTruckBiz, Inc.' src='https://etruckbizimages.s3.us-east-2.amazonaws.com/newLogo/primary-logo-color-rgb-8in%4072ppi.png' width='325'></img>
                </div>

                <div className='form-prompt'>
                    <h3>Thank you for signing up! Check your email for confirmation.</h3>
                </div>
            </div>
        );    
    }else{
        if(clientSecret){
            return( 
                <div className = 'container'>
                    <div className='logo'>
                        <img title='eTruckBiz, Inc.' alt='eTruckBiz, Inc.' src='https://etruckbizimages.s3.us-east-2.amazonaws.com/newLogo/primary-logo-color-rgb-8in%4072ppi.png' width='325'></img>
                    </div>
                    <div className = "s-box">
                        <Elements options={stripeOptions} stripe={stripePromise}>
                            <StripePaymentForm setStripeStatus = {setStripeStatus} clientSecret = {clientSecret}/>
                        </Elements> 
                    </div>
                </div>        
            );
        }else{
            return(
                <div className = 'container' id = "stripeBox">
                    <form onSubmit = {handleSubmit}>
                        {mainForm()}
                        {ClassSelectorContainer()}
                        <button 
                            disabled={classCart?.length < 1}
                            type="submit"
                        >
                            Proceed to Checkout
                        </button>
                    </form>
                    <p className = 'userMessage'>{userMsg}</p>
                </div>        
            );
        }
    }
} 
export default ClassSignup;